import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";

import "./Login.css";
import { SignInButton } from "./SignInButton";

const LoginContent = () => {
  return (
    <div className="loginBox">
      <img
        className="user"
        src="/login-image-01.png"
        height="100px"
        width="100px"
        alt="Logo"
      />
      <h3>Sign In Using Microsoft AD</h3>
      <div className="text-center">
        <SignInButton />
      </div>
    </div>
  );
};

const Login = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <div>
      {children}
      {isAuthenticated ? <div></div> : <LoginContent />}
    </div>
  );
};

export default Login;
